import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Card from '@material-ui/core/Card';
import CardHeader  from '@material-ui/core/CardHeader';
import CardContent  from '@material-ui/core/CardContent';
import CardActions  from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import red from '@material-ui/core/colors/red';
import DialogVideo from './DialogVideo';
import Grid from '@material-ui/core/Grid';
import * as STATIC from '../config/static';
import EditIcon from '@material-ui/icons//Edit';

import LocationOnIcon from '@material-ui/icons//LocationOn';

import ExpandMoreIcon from '@material-ui/icons//ExpandMore';
import Hidden from '@material-ui/core/Hidden';

import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import store from '../store';
import firebase from "firebase/app";
import "firebase/firestore";
import { phone, callWait } from '../config/static';
import  FormControl  from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import ReceiptIcon from '@material-ui/icons/Receipt';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import FileCopy from '@material-ui/icons/FileCopy';
import moment from 'moment'
import CloseIcon from '@material-ui/icons/Close';
import _ from 'lodash';
let SERVER_FILES = "https://firebasestorage.googleapis.com/v0/b/vnsuperbrain.appspot.com/o/files%2F";
const styles = theme => ({
    actions: {
        display: 'flex',
        padding: theme.spacing.unit * 2
    },
    avatar: {
        backgroundColor: red[500],
    },
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        marginLeft: 'auto',
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    search: {
        backgroundColor: '#fff',
        padding: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 2,
        borderRight: 'solid 1px #ededed',
        borderLeft: 'solid 1px #ededed',
        borderTop: 'solid 1px #ededed'
    }
})
function a(q, f) {
    try {
        if (q.toLowerCase().includes(f)) {
            return true;
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
}

let _this;
class CardVideo extends React.Component {
    constructor() {
        super();
        this.state = { expanded: false, open: false,openAssign:false,search: '',
        checked: [] };
        _this = this;
    }
    handleExpandClick = () => {
        this.setState({ expanded: !this.state.expanded });
    }

    handleOpen = () => {
        this.setState({
            open: !this.state.open,
        });
    }

    handleDelete= async() => {
        if(window.confirm("Bạn có muốn xoá?"))
        {
          if(this.props.item)
          {
            try {
            await firebase.storage().ref().child('files/' +this.props.item.uri).delete();
          }
          catch(e)
          {
            console.log(e);
          }
          await firebase.firestore().collection("files").doc(this.props.item.id).delete();
        }
    }
  }





    handleClose = value => {
        this.setState({ open: false });
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };



    render() {

        const { classes, item } = this.props;

        //const ACCOUNT = store.getState().ACCOUNT;
        var subheader = (<span>{item.uri}<br/>{moment(item.created).format('DD/MM/YYYY HH:mm')}</span>);

        //console.log(item); 
        return (
            <div>
                <Card key={item.id} style={{ marginBottom: 20 }}>
                    <CardHeader
                      avatar={item.uri ? <Avatar src={item.uri ? SERVER_FILES + item.uri + '?alt=media' : ''} /> : <Avatar aria-label="Recipe" className={classes.avatar}>
                    {(item.name[0]).toUpperCase()}
                    </Avatar>}
                        action={
                            <div style={{ marginTop: 6 }}>
                                <Hidden xsDown>
                                  <IconButton aria-label="Edit" onClick={()=>{navigator.clipboard.writeText(SERVER_FILES + item.uri + '?alt=media');STATIC.NotificationManager.success("Đã copy link")}} style={{ backgroundColor: '#eee', color: '#555', marginRight: 12 }}>
                                      <FileCopy />
                                  </IconButton>
                                    <IconButton aria-label="Edit" onClick={this.handleDelete} style={{ backgroundColor: 'red', color: '#555', marginRight: 12 }}>
                                        <CloseIcon />
                                    </IconButton>
                                    </Hidden></div>}
                        title={item.name}
                        subheader={subheader}
                    />
                    <Hidden smUp>
                        <CardActions className={classes.actions} disableActionSpacing>


                            <IconButton aria-label="Edit" onClick={this.handleOpen} style={{ backgroundColor: '#eee', color: '#555', marginRight: 12 }}>
                                Delete
                            </IconButton>

                        </CardActions>
                    </Hidden>


                </Card>
                {this.state.open ? <DialogVideo
                    item={item}
                    cats={this.props.cats}
                    fullScreen={true}
                    open={this.state.open}
                    onClose={this.handleClose}
                /> : ''}
            </div>
        )
    }
}

CardVideo.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CardVideo);
